import React from "react";
import PropTypes from "prop-types";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import MenuItem from "@material-ui/core/MenuItem";
import deburr from "lodash/deburr";
import Part from "./autocomplete-suggestion-part";

const MAX_SUGGESTIONS = 5;

const SuggestionComponent = ({ isHighlighted, parts }) => (
  <MenuItem selected={isHighlighted} component="div">
    <div>
      {parts.map((part, index) => (
        <Part key={String(index)} index={index} part={part} />
      ))}
    </div>
  </MenuItem>
);
SuggestionComponent.propTypes = {
  /**
   * Indica si está seleccionado
   */
  isHighlighted: PropTypes.bool,
  /**
   * Elementos paginados en un objeto con la colección y el total
   **/
  parts: PropTypes.array,
};

export function renderSuggestion(getSuggestionValue) {
  return function renderSuggestionWhenMatches(suggestion, { query, isHighlighted }) {
    const matches = match(getSuggestionValue(suggestion), query);
    const parts = parse(getSuggestionValue(suggestion), matches);

    return <SuggestionComponent isHighlighted={isHighlighted} parts={parts} />;
  };
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export const getSuggestions = (value = "", suggestions = [], getSuggestionValue) => {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : suggestions
        .filter(suggestion => {
          const keep =
            count < MAX_SUGGESTIONS &&
            getSuggestionValue(suggestion)
              .toLowerCase()
              .includes(inputValue);
          if (keep) {
            count += 1;
          }

          return keep;
        })
        .filter(onlyUnique);
};
